import { useTranslation } from "react-i18next";
import { FunctionComponent, useEffect, useState } from "react";
import { Layout, Tabs, TabsProps } from "antd";
import { useLocation } from "react-router-dom";
import PageHeader from "../../../../components/page-header/PageHeader";
import SurveyPlanInfo from "../../../../components/course-construction/survey-plan/survey-detail/plan-info/PlanInfo";
import PlanDetail from "../../../../components/course-construction/survey-plan/survey-detail/plan-detail/PlanDetail";
import OperationHistory from "../../../../components/course-construction/survey-plan/survey-detail/operation-history/OperationHistory";
import ActiveSetting from "../../../../components/course-construction/survey-plan/survey-detail/active-setting/ActiveSetting";
import { getSurveyPlanById } from "../../../../service/course-construct/survey-plan";
import SafeLink from "../../../../components/link/SafeLink";
import { routesConfig } from "../../../../config/routes";
import SurveyQuestionTab from "../../../../components/course-construction/survey-plan/survey-detail/survey-question";
import { getIdIndexDB } from "../../../page-builder/grapesjs-service";

const { Content } = Layout;
const imgPath = "/images/";

interface QuizLayoutProps {
  id?: number;
  code?: string;
  name?: string;
  surveyMethod?: boolean;
  timeStart?: string;
  timeEnd?: string;
  description?: string;
  targetType?: number;
  targetValue?: string;
  targetDescription?: string;
  applicatbleObjectKey?: boolean;
  applicatbleObjectSchools?: string;
  applicatbleCourseRegister?: null;
  applicatbleCourseCompleted?: null;
  applicatbleIndustry?: null;
  isDeleted?: boolean;
  statusSurvey?: string;
  createdDate?: null;
  createdBy?: null;
}

const SurveyPlanDetail: FunctionComponent = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isShowSubmitButton, setIsShowSubmitButton] = useState(true);
  let idSurveyPlan = '';
  const { id } = location.state.record
  const [surveyPlan, setSurveyPlan] = useState<QuizLayoutProps>();

  const [tab, setTab] = useState<string>("")


  const getSurveyPlan = async (id: number) => {
    try {
      const res = await getSurveyPlanById(id);
      setSurveyPlan(res.data.data);
    } catch (error) {
      console.error();
    }
  };

  const currentUrl = window.location.href;

  // Parse the URL using the URL object
  const url = new URL(currentUrl);

  // Split the pathname into segments
  const pathSegments = url.pathname.split("/");

  // The last segment will be the last digit you want
  const lastDigit = pathSegments.pop();

  getIdIndexDB('current-course', (val: any) => {
    if (val) {
      idSurveyPlan = (val.isEdit);
    }
  });

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: t("Thông tin kế hoạch", "Thông tin kế hoạch"),
      children: (
        <>
          <SurveyPlanInfo surveyPlan={surveyPlan} />
        </>
      ),
    },
    {
      key: "2",
      label: t("Kế hoạch chi tiết", "Kế hoạch chi tiết"),
      children: (
        // change children here
        <PlanDetail surveyPlan={surveyPlan} />
      ),
    },
    {
      key: "3",
      // icon: <LockOutlined />,
      label: t("Cài đặt hoạt động", "Cài đặt hoạt động"),
      children: (
        // change children here
        <ActiveSetting data={surveyPlan} />
      ),
    },
    {
      key: "4",
      label: t("Lịch sử thao tác", "Lịch sử thao tác"),
      children: (
        // change children here
        <OperationHistory surveyPlan={surveyPlan} />
      ),
    },
    {
      key: "5",
      label: t("Câu hỏi khảo sát", "Câu hỏi khảo sát"),
      children: (
        // change children here
        <SurveyQuestionTab id={id} tab={tab} />
      ),
    },
  ];

  const listBreadcrumb = [
    {
      title: t("Xây dựng khóa học", "Xây dựng khóa học"),
    },
    {
      title: <SafeLink to={`/${routesConfig.courseConstruction}/${routesConfig.surveyPlan}`}>
        <span>{t("Kế hoạch khảo sát", "Kế hoạch khảo sát")}</span>
      </SafeLink>,
    },
    {
      title: surveyPlan?.name,
    },
  ];

  // Handle change tabs
  const handleChange = (activeKey: string) => {
    setTab(activeKey)
    getSurveyPlan(Number(lastDigit));
    setIsShowSubmitButton(true);
  };

  // useEffect
  useEffect(() => {
    getSurveyPlan(Number(lastDigit));
  }, [lastDigit]);

  return (
    <>
      <Content>
        <PageHeader
          title={surveyPlan?.name ? surveyPlan?.name : ""}
          listBreadcrumb={listBreadcrumb}
          arrowLeft={imgPath + "arrowLeft.svg"}
          positionItem="column"
          breadcrumb={true}
          headerGroupButton={isShowSubmitButton}
        />
        <div className="tabs-heading">
          <Tabs defaultActiveKey="1" onChange={handleChange} items={items} />
        </div>

      </Content>
    </>
  );
};

export default SurveyPlanDetail;
